import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../nodeInstance";

export default function UploadFilePopUp_New({
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  setTrigger,
  trigger,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState(null);   // { errors: [...], totalUpdatedRows, message }
  const [showErrors, setShowErrors] = useState(false);

  const reset = () => {
    setFile(null);
    setErrors(null);
    setShowErrors(false);
  };

  const handleClose = () => {
    reset();
    setPopUp(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!file) return;

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await nodeinstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        // No timeout — large files can take time
        timeout: 0,
      });

      if (response.status === 200) {
        const data = response.data;

        if (data?.errors?.length > 0) {
          // Partial success — show errors, keep modal open
          setErrors(data);
          setShowErrors(true);
          dispatch(setAppError({
            msg: `${data.totalUpdatedRows || 0} updated. ${data.errors.length} row(s) had errors.`,
            color: "success",
          }));
        } else {
          dispatch(setAppError({
            msg: `${data.totalUpdatedRows || 0} records updated successfully.`,
            color: "success",
          }));
          handleClose();
        }

        // Always refresh the table
        if (callBack) callBack();
        if (setTrigger) setTrigger((prev) => !prev);
      }
    } catch (err) {
      console.error("Upload error:", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Upload failed. Please try again.";
      dispatch(setAppError({ msg }));
    } finally {
      setLoading(false);
    }
  };

  if (!PopUp) return null;

  return (
    <div className="fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 flex justify-center items-center">
      <div className="max-w-lg w-full rounded-md bg-white flex flex-col p-4 relative">
        {/* Header */}
        <div className="flex justify-between items-center w-full mb-3">
          <h2 className="text-base font-semibold uppercase">{title}</h2>
          <button onClick={handleClose} className="text-gray-500 hover:text-black">
            <IoMdClose size="1.3rem" />
          </button>
        </div>

        {/* Body */}
        <div className="w-full overflow-y-auto max-h-[70vh]">
          {showErrors && errors?.errors?.length > 0 ? (
            <div>
              <p className="text-sm font-semibold mb-2 text-red">
                {errors.errors.length} row(s) failed:
              </p>
              <div className="flex flex-col gap-1 max-h-64 overflow-y-auto text-sm">
                {errors.errors.map((err, i) => (
                  <p key={i} className="text-gray-700">
                    <span className="font-medium">{err.employeeId}</span>
                    {" — "}
                    <span className="text-red">{err.error}</span>
                  </p>
                ))}
              </div>
              <button
                className="mt-4 p-2 px-4 bg-blue text-white rounded-md text-sm"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          ) : (
            <form onSubmit={submitHandler} className="w-full">
              <div className="flex flex-col gap-3 my-3 p-2">
                <div className="form-control w-full">
                  <label className="label">
                    <span className="label-text text-sm">Select Excel file (.xlsx / .xls)</span>
                  </label>
                  <input
                    type="file"
                    className="file-input file-input-bordered w-full"
                    accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                  />
                  {file && (
                    <p className="text-xs text-gray-500 mt-1">
                      {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={loading || !file}
                  className="p-3 bg-red text-white rounded-md w-full flex gap-2 justify-center items-center text-sm disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <>
                      <CgSpinner className="animate-spin" />
                      Uploading...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
